import React from "react";
import SocialItem from "./Social_item";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="row">
          <div className="footer__main">
            <div className="footer__logo">
              <Link to="/">
                <img
                  src="https://i.ibb.co/MMg1kXh/maruf-img-3.jpg"
                  alt="maruf"
                />
              </Link>
            </div>
            <div className="footer__email">
              <a href="mailto:mmaruf1137@gmail.com">
                <h2 className="heading">mmaruf1137@gmail.com</h2>
              </a>
            </div>
          </div>
          <div className="footer__sub">
            <p className="p-text">copyright by maruf 2021</p>
            <SocialItem />
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
